import { Component } from '@angular/core';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseComponent } from '@m4u-angular/base/component/BaseComponent';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { NotificationService } from '@m4u-angular/core/framework/notification.service';
import { Subscription } from 'rxjs';

class State extends BaseState {
    UnreadCount: number;
}

@Component({
    providers: ServiceBagServices,
    selector: 'app-push-message-badge',
    templateUrl: './push-message-badge.component.html',
    styleUrls: ['./push-message-badge.component.scss']
})
export class PushMessageBadgeComponent extends BaseComponent<State> {

    private _subscription: Subscription;

    constructor(A: ServiceBagService,
        private notificationService: NotificationService) {
        super(A, 'PushMessageBadgeComponent', State);
    }

    protected override OnInitComponent(): void {
        this._subscription = this.notificationService.NotificationUnread$
            .subscribe((unreadCount) => this.State.UnreadCount = unreadCount);
    }

    protected override OnDestroyComponent(): void {
       this._subscription && this._subscription.unsubscribe();
    }
}
